<div class="container">
    <nb-card>
        <nb-card-body>
            <div class="auth-block">
                <router-outlet></router-outlet>
            </div>
        </nb-card-body>
    </nb-card>
</div>
